// ── 위젯을 눌러 들어간 메뉴를 못 여는 사람에게 메뉴 자리에 보이는 안내 (2026-10-24) ─────────────────
// 사용자 결정(a): "위젯은 보여주지만, 위젯을 클릭했을때 메뉴안을 '볼 권한이 없어요' 가 맞아."
//   문구는 2026-10-24 결정(c)로 부드럽게 — 보는 직원 기분을 생각해 "권한이 없다" 대신 "담당자가 쓰는 화면".
//   SbContent 가 그 위젯을 누르면 메뉴 주소로 가면서 state.widgetNoAccess 를 싣고, AdminLayout 이 메뉴 화면 대신 이걸 그린다
//   (메뉴 화면을 아예 띄우지 않아 닫힌 데이터 문을 두드리지 않는다). 주소를 직접 열면 종전과 같다.
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function WidgetNoAccess() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center py-24 px-4">
      <div className="w-full max-w-[420px] rounded-2xl border border-[var(--border)] bg-[var(--bg-card)] px-6 py-10 text-center">
        <div className="text-xl font-bold text-[var(--text)]">이 메뉴는 담당자가 쓰는 화면이에요</div>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mt-6 inline-flex items-center justify-center rounded-xl px-4 py-2.5 text-sm font-bold text-white bg-slate-900 hover:bg-slate-700 dark:bg-accent-600 dark:hover:bg-accent-500 cursor-pointer"
        >
          상황판으로 돌아가기
        </button>
      </div>
    </div>
  );
}
